import { isEmpty } from 'lodash-es';

type DividerProps = {
  subheading?: string;
  as?: 'h1' | 'h2' | 'h3' | 'h4' | 'span';
};

export const Divider = ({ subheading, as: Element = 'h2' }: DividerProps) => {
  if (isEmpty(subheading)) {
    return (
      <hr className="tds-divider tds-divider-line" />
    );
  } else {
    return (
      <div className="relative flex items-center tds-divider">
        <Element className="absolute tds-divider-subheading left-200">{subheading}</Element>
        <hr className="flex-grow tds-divider-line"/>
      </div>
    );
  }
};
